import React from 'react';
import styled from 'styled-components';

interface ICatalogLoading {
  bars?: any,
  barsHeader?: any
}

const ComponentWrapper = styled.div`
  display: block;
  height: 100%;
  width: 100%;
  margin-top: 31px;

  @-webkit-keyframes flash {
    0%, 50%, 100% {
      opacity: 1;
    }
    25%, 75% {
      opacity: .5;
    }
  }
  @keyframes flash {
    0%, 50%, 100% {
      opacity: 1;
    }
    25%, 75% {
      opacity: .5;
    }
  }
`;

const ContentBarHeader = styled.div`
  margin-bottom: 48px;
  .bar {
    background: linear-gradient(270deg, rgba(164, 164, 164, 0.1) 0%, rgba(0, 0, 0, 0.1) 61.93%);
    height: 19px;
    margin-bottom: 14px;
    -webkit-animation: flash 3s both infinite;
  }
  & > div:nth-of-type(1) .bar {
    background: linear-gradient(270deg, rgba(164, 164, 164, 0.1) 0%, rgba(0, 0, 0, 0.1) 61.93%);
    height: 32px;
  }
`;

const ContentBar = styled.div`
  margin-bottom: 20px;
`;

const ContentBody = styled.div`
  & > div:nth-of-type(1) .bar {
    background: #DEDEDE !important;
  }
  & > div:nth-child(2n) .bar {
    background: linear-gradient(270deg, rgba(164, 164, 164, 0.1) 0%, rgba(0, 0, 0, 0.1) 61.93%);
  }
  & > div:nth-child(2n+1) .bar {
    background: linear-gradient(270deg, rgba(164, 164, 164, 0.1) 0%, rgba(0, 0, 0, 0.1) 61.93%);
  }
`;

const Bar = styled.div.attrs(() => ({ className: 'bar' }))`
  border-radius: 4px;
  animation: flash 3s both infinite;
  height: 100px;
  width: 100%;
`;


const CatalogLoading: React.FC<ICatalogLoading> = (props) => {
  const {
    bars = ['100%', '100%', '40%'],
    barsHeader = [],
  } = props;
  return (
    <ComponentWrapper className="skeleton-wrapper">
      <ContentBarHeader className="skeleton-header">
        {barsHeader.map((value: any, index: number) => (
          <ContentBar style={{ width: value }} key={index} className="skeleton-content-bar">
            <Bar />
          </ContentBar>
        ))}
      </ContentBarHeader>
      <ContentBody className="skeleton-body">
        {bars.map((value: any, index: number) => (
          <ContentBar style={{ width: value }} key={index} className="skeleton-content-bar">
            <Bar />
          </ContentBar>
        ))}
      </ContentBody>
    </ComponentWrapper>
  );
};

export default CatalogLoading;
